export function isBetween (value, { min, max }) {
  return (value || value === 0) && value >= min && value <= max
}
